import { Id } from '@nextforce/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import { useChatWebsocketContext } from 'chat/websocket/context'
import { updateConversationLastViewedTimestamp } from './queries/shared/utils'

export function useUpdateConversationLastViewed(conversationId: Id) {
  const { server } = useServer()
  const client = useQueryClient()
  const { sendWebsocketMessage } = useChatWebsocketContext()

  return useMutation({
    mutationFn: updateConversationLastViewed,
    onSuccess: async updatedTimestamp => {
      await updateConversationLastViewedTimestamp(
        client,
        conversationId,
        updatedTimestamp
      )

      sendWebsocketMessage({
        action: 'updateLastViewedTimestampEvent',
        lastViewedTimestampUpdateEvent: {
          lastViewedTimestamp: updatedTimestamp,
          conversationId: conversationId,
        },
      })
    },
  })

  async function updateConversationLastViewed() {
    return server.put<number>(
      `/v2/chat/conversations/${conversationId}/last_viewed`,
      {}
    )
  }
}
